import styled from "@emotion/styled";
import WarningComponent from "../../Warning";

export const Warning = styled(WarningComponent)`
  --Warning-background-color: var(--color-notification-notice-extra-light);
  --Warning-Icon-color: var(--notice-color);
`;
